const columns = [
    {
      title: 'Account No',
      dataIndex: 'accountNo',
    },
    {
      title: 'A/C Type',
      dataIndex: 'acType',
    },
    {
      title: 'Balance',
      dataIndex: 'balance',
    },
    {
      title: 'Leverage',
      dataIndex: 'leverage',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
    },
  ];
  
  export default columns;